import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const DELETE_BIDDER: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deleteWorkspaceBidder($input: DeleteWorkspaceBidderInput!) {
    deleteWorkspaceBidder(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
